import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDateTime: any;
};

export enum AcademicPartnerAcademicModel {
  MODEL_A = 'MODEL_A',
  MODEL_L = 'MODEL_L',
  MODEL_M = 'MODEL_M',
  MODEL_S = 'MODEL_S',
  UNKNOWN = 'UNKNOWN'
}

export enum ApRegion {
  INTERNATIONAL = 'INTERNATIONAL',
  MIDWEST = 'MIDWEST',
  NORTHEAST = 'NORTHEAST',
  ONLINE = 'ONLINE',
  SOUTH = 'SOUTH',
  SOUTHEAST = 'SOUTHEAST',
  WEST = 'WEST'
}

export enum ApState {
  ARIZONA = 'ARIZONA',
  CALIFORNIA = 'CALIFORNIA',
  COLORADO = 'COLORADO',
  CONNECTICUT = 'CONNECTICUT',
  DELAWARE = 'DELAWARE',
  FLORIDA = 'FLORIDA',
  GEORGIA = 'GEORGIA',
  ILLINOIS = 'ILLINOIS',
  INDIANA = 'INDIANA',
  LOUISIANA = 'LOUISIANA',
  MARYLAND = 'MARYLAND',
  MASSACHUSETTS = 'MASSACHUSETTS',
  MICHIGAN = 'MICHIGAN',
  MINNESOTA = 'MINNESOTA',
  NEBRASKA = 'NEBRASKA',
  NEW_HAMPSHIRE = 'NEW_HAMPSHIRE',
  NEW_JERSEY = 'NEW_JERSEY',
  NEW_YORK = 'NEW_YORK',
  NORTH_CAROLINA = 'NORTH_CAROLINA',
  OHIO = 'OHIO',
  OKLAHOMA = 'OKLAHOMA',
  OREGON = 'OREGON',
  PENNSYLVANIA = 'PENNSYLVANIA',
  RHODE_ISLAND = 'RHODE_ISLAND',
  TEXAS = 'TEXAS',
  VIRGINIA = 'VIRGINIA',
  WASHINGTON_DC = 'WASHINGTON_DC',
  WISCONSIN = 'WISCONSIN'
}

export enum CompletionTimeDisplay {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export enum ProgramContentItemCategory {
  CONCENTRATION = 'CONCENTRATION',
  COURSE_OPTION = 'COURSE_OPTION',
  PREREQUISITE = 'PREREQUISITE',
  REQUIREMENTS_LOCATION = 'REQUIREMENTS_LOCATION',
  REQUIREMENTS_OTHER = 'REQUIREMENTS_OTHER',
  REQUIREMENTS_SKILLS = 'REQUIREMENTS_SKILLS',
  REQUIREMENTS_TECHNOLOGY = 'REQUIREMENTS_TECHNOLOGY',
  REQUIREMENTS_WORK = 'REQUIREMENTS_WORK',
  SKILL = 'SKILL'
}

export enum InstructionKind {
  INSTRUCTOR_LED = 'INSTRUCTOR_LED',
  SELF_DIRECTED = 'SELF_DIRECTED'
}

export enum TrackDateStatusType {
  EXPIRED = 'EXPIRED',
  EXPIRING_SOON = 'EXPIRING_SOON',
  FUTURE = 'FUTURE',
  LIVE = 'LIVE',
  PAST = 'PAST'
}

export enum NotApplicable {
  COLLEGE_CREDITS_NOT_APPLICABLE = 'COLLEGE_CREDITS_NOT_APPLICABLE',
  COLLEGE_GPA_NOT_APPLICABLE = 'COLLEGE_GPA_NOT_APPLICABLE',
  CONCENTRATIONS_NOT_APPLICABLE = 'CONCENTRATIONS_NOT_APPLICABLE',
  COURSES_INCLUDED_NOT_APPLICABLE = 'COURSES_INCLUDED_NOT_APPLICABLE',
  HS_GPA_NOT_APPLICABLE = 'HS_GPA_NOT_APPLICABLE',
  LOCATION_NOT_APPLICABLE = 'LOCATION_NOT_APPLICABLE',
  OTHER_REQUIREMENTS_NOT_APPLICABLE = 'OTHER_REQUIREMENTS_NOT_APPLICABLE',
  REQUIRED_SKILLS_NOT_APPLICABLE = 'REQUIRED_SKILLS_NOT_APPLICABLE',
  SKILLS_NOT_APPLICABLE = 'SKILLS_NOT_APPLICABLE',
  TECHNOLOGY_NOT_APPLICABLE = 'TECHNOLOGY_NOT_APPLICABLE',
  WORK_EXPERIENCE_NOT_APPLICABLE = 'WORK_EXPERIENCE_NOT_APPLICABLE'
}

export enum Pacing {
  FLEXIBLE_PACING = 'FLEXIBLE_PACING',
  GUIDED_PACING = 'GUIDED_PACING'
}

export enum ProgramKind {
  ADVANCED_CERTIFICATE = 'ADVANCED_CERTIFICATE',
  ASSOCIATE_OF_ARTS_DEGREE = 'ASSOCIATE_OF_ARTS_DEGREE',
  ASSOCIATE_OF_SCIENCE_DEGREE = 'ASSOCIATE_OF_SCIENCE_DEGREE',
  BACHELOR_OF_APPLIED_SCIENCE = 'BACHELOR_OF_APPLIED_SCIENCE',
  BACHELOR_OF_ARTS_DEGREE = 'BACHELOR_OF_ARTS_DEGREE',
  BACHELOR_OF_BUSINESS_ADMINISTRATION = 'BACHELOR_OF_BUSINESS_ADMINISTRATION',
  BACHELOR_OF_GENERAL_STUDIES = 'BACHELOR_OF_GENERAL_STUDIES',
  BACHELOR_OF_PROFESSIONAL_SERVICE_DEGREE = 'BACHELOR_OF_PROFESSIONAL_SERVICE_DEGREE',
  BACHELOR_OF_SCIENCE_DEGREE = 'BACHELOR_OF_SCIENCE_DEGREE',
  CERTIFICATE = 'CERTIFICATE',
  COLLEGE_PREP = 'COLLEGE_PREP',
  DOCTOR_OF_HEALTH_SCIENCES = 'DOCTOR_OF_HEALTH_SCIENCES',
  DOCTOR_OF_MIDWIFERY = 'DOCTOR_OF_MIDWIFERY',
  DOCTOR_OF_NURSING_PRACTICE = 'DOCTOR_OF_NURSING_PRACTICE',
  DOCTOR_OF_PHYSICAL_THERAPY = 'DOCTOR_OF_PHYSICAL_THERAPY',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  INTERMEDIATE_CERTIFICATE = 'INTERMEDIATE_CERTIFICATE',
  INTRODUCTORY_CERTIFICATE = 'INTRODUCTORY_CERTIFICATE',
  LANGUAGE = 'LANGUAGE',
  MASTER_OF_ARTS_DEGREE = 'MASTER_OF_ARTS_DEGREE',
  MASTER_OF_BUSINESS_ADMINISTRATION = 'MASTER_OF_BUSINESS_ADMINISTRATION',
  MASTER_OF_HEALTHCARE_ADMINISTRATION = 'MASTER_OF_HEALTHCARE_ADMINISTRATION',
  MASTER_OF_PUBLIC_ADMINISTRATION = 'MASTER_OF_PUBLIC_ADMINISTRATION',
  MASTER_OF_PUBLIC_HEALTH = 'MASTER_OF_PUBLIC_HEALTH',
  MASTER_OF_SCIENCE_DEGREE = 'MASTER_OF_SCIENCE_DEGREE',
  PROFESSIONAL_DEVELOPMENT = 'PROFESSIONAL_DEVELOPMENT'
}

export enum MinEduLevel {
  BACHELORS_DEGREE = 'BACHELORS_DEGREE',
  HIGH_SCHOOL_DIPLOMA = 'HIGH_SCHOOL_DIPLOMA',
  MASTERS_DEGREE = 'MASTERS_DEGREE',
  SOME_COLLEGE = 'SOME_COLLEGE',
  SOME_HIGH_SCHOOL = 'SOME_HIGH_SCHOOL'
}

export enum ShortProgramKind {
  ASSOCIATES = 'ASSOCIATES',
  BACHELORS = 'BACHELORS',
  CERTIFICATE = 'CERTIFICATE',
  COLLEGE_PREP = 'COLLEGE_PREP',
  DOCTORAL = 'DOCTORAL',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  LANGUAGE = 'LANGUAGE',
  MASTERS = 'MASTERS',
  PROFESSIONAL_DEVELOPMENT = 'PROFESSIONAL_DEVELOPMENT'
}

export enum ProgramStatus {
  ACTIVE = 'ACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  INACTIVE = 'INACTIVE'
}

export enum AcademicPartnerContentItemCategory {
  ABOUT = 'ABOUT',
  APPLICATION_PREP = 'APPLICATION_PREP',
  APPLICATION_STEP = 'APPLICATION_STEP'
}

export enum AcademicPartnerEndorsementCategory {
  AWARD = 'AWARD',
  TESTIMONIAL = 'TESTIMONIAL'
}

export enum AcademicPartnerLocationType {
  MULTIPLE_LOCATIONS = 'MULTIPLE_LOCATIONS',
  MULTIPLE_LOCATIONS_MAIN_LOCATION = 'MULTIPLE_LOCATIONS_MAIN_LOCATION',
  ONLINE_ONLY = 'ONLINE_ONLY',
  SINGLE_LOCATION = 'SINGLE_LOCATION'
}

export enum AcademicPartnerMerchandisingTier {
  AFFILIATE = 'AFFILIATE',
  ENHANCED = 'ENHANCED',
  LIGHT = 'LIGHT',
  STANDARD = 'STANDARD',
  UNKNOWN = 'UNKNOWN'
}

export type UserOverridesInput = {
  employer_uuid?: InputMaybe<Scalars['ID']>;
  employerUuid?: InputMaybe<Scalars['ID']>;
  user_uuid?: InputMaybe<Scalars['ID']>;
  userUuid?: InputMaybe<Scalars['ID']>;
};

export type RecommendationsInput = {
  levelOfEducation?: InputMaybe<LevelOfEducation>;
  memberUuid: Scalars['ID'];
  numberRecs?: InputMaybe<Scalars['Int']>;
  recommendationCategory?: InputMaybe<RecommendationCategory>;
};

export enum LevelOfEducation {
  AA_DEGREE = 'AA_DEGREE',
  ADVANCED_DEGREE = 'ADVANCED_DEGREE',
  BACHELORS_DEGREE = 'BACHELORS_DEGREE',
  HIGH_SCHOOL_DIPLOMA = 'HIGH_SCHOOL_DIPLOMA',
  SOME_COLLEGE = 'SOME_COLLEGE',
  SOME_HIGH_SCHOOL = 'SOME_HIGH_SCHOOL',
  VOCATIONAL_SCHOOL = 'VOCATIONAL_SCHOOL'
}

export enum RecommendationCategory {
  MOST_POPULAR = 'MOST_POPULAR',
  PERSONALIZED = 'PERSONALIZED'
}

export enum RecommendationTypeEnum {
  COLLAB_FILTERING = 'COLLAB_FILTERING',
  DEFAULT = 'DEFAULT',
  EP = 'EP',
  EP_ED = 'EP_ED'
}

export type RecommendationsInputV2 = {
  employerUuid: Scalars['ID'];
  levelOfEducation?: InputMaybe<LevelOfEducation>;
  memberUuid: Scalars['ID'];
  numberRecs?: InputMaybe<Scalars['Int']>;
  recommendationCategory?: InputMaybe<RecommendationCategory>;
};

export enum QuizScreenName {
  COLLEGE_GPA = 'COLLEGE_GPA',
  CREDITS = 'CREDITS',
  EDUCATION = 'EDUCATION',
  FEELING = 'FEELING',
  GOAL = 'GOAL',
  HS_GPA = 'HS_GPA',
  INTERESTS = 'INTERESTS',
  TIME_TO_COMPLETE = 'TIME_TO_COMPLETE',
  WEEKLY_TIME = 'WEEKLY_TIME'
}

export enum QuizSource {
  CATALOG_FRONTEND = 'CATALOG_FRONTEND',
  PROFILE_COMPLETION_SERVICE = 'PROFILE_COMPLETION_SERVICE',
  QUIZ_DATA_MIGRATION = 'QUIZ_DATA_MIGRATION'
}

export type CommitMerchDataInput = {
  jobId: Scalars['ID'];
};

export enum ImportJobStatus {
  ABORTED = 'ABORTED',
  COMMITTED = 'COMMITTED',
  STAGED = 'STAGED',
  UNKNOWN = 'UNKNOWN'
}

export type CreateApInput = {
  academicPartnerData: AcademicPartnerInput;
  academicPartnerUuid: Scalars['ID'];
};

export type AcademicPartnerInput = {
  academicModel?: InputMaybe<Scalars['String']>;
  accredited?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  apRegion?: InputMaybe<ApRegion>;
  apState?: InputMaybe<ApState>;
  campusPhotoHeader?: InputMaybe<Logo>;
  campusPhotoInstitution?: InputMaybe<Logo>;
  coachingIncluded?: InputMaybe<Scalars['Boolean']>;
  colorLogo?: InputMaybe<Logo>;
  kind: Scalars['String'];
  link?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  locationType?: InputMaybe<Scalars['String']>;
  logoAltText?: InputMaybe<Scalars['String']>;
  merchandisingTier?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nonProfit?: InputMaybe<Scalars['Boolean']>;
  overview?: InputMaybe<Scalars['String']>;
  parentName?: InputMaybe<Scalars['String']>;
  supportsCreditForTraining?: InputMaybe<Scalars['Boolean']>;
  videoId?: InputMaybe<Scalars['String']>;
  whiteLogo?: InputMaybe<Logo>;
};

export type Logo = {
  content?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateBookmarksInput = {
  programIds: Array<InputMaybe<Scalars['Int']>>;
};

export type CreateCoachRecommendationsInput = {
  message?: InputMaybe<Scalars['String']>;
  programIds: Array<InputMaybe<Scalars['ID']>>;
  userOverrides: UserOverridesInput;
};

export type CreateNotifyOptInInput = {
  programId: Scalars['ID'];
};

export enum ResponseStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
  UNKNOWN = 'UNKNOWN'
}

export type ProgramInput = {
  academicPartnerUuid?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  advisorIncluded?: InputMaybe<Scalars['Boolean']>;
  applicationFeeCents?: InputMaybe<Scalars['Int']>;
  brandedAcademicPartnerUuid?: InputMaybe<Scalars['String']>;
  catalogCardDescription?: InputMaybe<Scalars['String']>;
  cipCode?: InputMaybe<Scalars['String']>;
  completionTimeDisplay?: InputMaybe<CompletionTimeDisplay>;
  description?: InputMaybe<Scalars['String']>;
  instructionKind?: InputMaybe<InstructionKind>;
  keywords?: InputMaybe<Scalars['String']>;
  maxCompletionTime?: InputMaybe<Scalars['Int']>;
  maxEffortHours?: InputMaybe<Scalars['Int']>;
  minCompletionTime?: InputMaybe<Scalars['Int']>;
  minEffortHours?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notApplicable?: InputMaybe<Array<InputMaybe<NotApplicable>>>;
  pacing?: InputMaybe<Pacing>;
  programFormat?: InputMaybe<Scalars['String']>;
  programKind?: InputMaybe<ProgramKind>;
  requirements?: InputMaybe<ProgramRequirementsInputType>;
  schedLiveInstruction?: InputMaybe<Scalars['String']>;
  shortProgramKind?: InputMaybe<ShortProgramKind>;
  status?: InputMaybe<ProgramStatus>;
  studentFacingAcademicPartnerUuid?: InputMaybe<Scalars['String']>;
  syllabusLink?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ProgramRequirementsInputType = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  minCollegeCredits?: InputMaybe<Scalars['Int']>;
  minCollegeCreditsDetails?: InputMaybe<Scalars['String']>;
  minCollegeGpa?: InputMaybe<Scalars['Float']>;
  minCollegeGpaDetails?: InputMaybe<Scalars['String']>;
  minEduLevel?: InputMaybe<MinEduLevel>;
  minEduLevelDetails?: InputMaybe<Scalars['String']>;
  minHsGpa?: InputMaybe<Scalars['Float']>;
  minHsGpaDetails?: InputMaybe<Scalars['String']>;
  minSkillRequirements?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minTechAccessRequirements?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']>;
};

export type CreateRecommendationsAndQuizResponsesInput = {
  programIds: Array<InputMaybe<Scalars['Int']>>;
  quizResponses: Array<InputMaybe<CreateQuizResponseInput>>;
};

export type CreateQuizResponseInput = {
  ordering: Scalars['Int'];
  response?: InputMaybe<QuizResponseContentInput>;
  screenName?: InputMaybe<QuizScreenName>;
  source?: InputMaybe<QuizSource>;
};

export type QuizResponseContentInput = {
  booleanChoice?: InputMaybe<Scalars['Boolean']>;
  multipleChoice?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  singleChoice?: InputMaybe<Scalars['String']>;
};

export type UpdateApInput = {
  academicPartnerData: AcademicPartnerInput;
  academicPartnerUuid: Scalars['ID'];
};

export type AcademicPartnerContentItemsInput = {
  academicPartnerUuid: Scalars['ID'];
  contentItemDatum?: InputMaybe<Array<InputMaybe<AcademicPartnerContentItem>>>;
};

export type AcademicPartnerContentItem = {
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateApEndorsementsInput = {
  academicPartnerUuid: Scalars['ID'];
  endorsements?: InputMaybe<Array<InputMaybe<AcademicPartnerEndorsementItem>>>;
};

export type AcademicPartnerEndorsementItem = {
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<AcademicPartnerEndorsementCategory>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Logo>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateProgramContentItemsInput = {
  contentItems?: InputMaybe<Array<InputMaybe<ProgramContentItem>>>;
  programId: Scalars['ID'];
};

export type ProgramContentItem = {
  body?: InputMaybe<Scalars['String']>;
  category: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateProgramFacetsInput = {
  facetOptionIds: Array<InputMaybe<Scalars['ID']>>;
  programId: Scalars['ID'];
};

export type UpdateProgramRequirementsInput = {
  programId: Scalars['ID'];
  requirements: ProgramRequirementsInputType;
};

export type UpdateAcademicPartnerInput = {
  academicModel: Scalars['String'];
  accredited?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  campusPhotoHeader?: InputMaybe<Logo>;
  campusPhotoInstitution?: InputMaybe<Logo>;
  coachingIncluded?: InputMaybe<Scalars['Boolean']>;
  colorLogo?: InputMaybe<Logo>;
  kind: Scalars['String'];
  link?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  locationType?: InputMaybe<Scalars['String']>;
  logoAltText?: InputMaybe<Scalars['String']>;
  merchandisingTier?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nonProfit?: InputMaybe<Scalars['Boolean']>;
  overview?: InputMaybe<Scalars['String']>;
  parentName?: InputMaybe<Scalars['String']>;
  supportsCreditForTraining?: InputMaybe<Scalars['Boolean']>;
  videoId?: InputMaybe<Scalars['String']>;
  whiteLogo?: InputMaybe<Logo>;
};

export type GetBookmarksQueryVariables = Exact<{
  version?: InputMaybe<Scalars['String']>;
}>;


export type GetBookmarksQuery = { bookmarks?: Array<{ program?: { id: string, uuid: string } | null } | null> | null };

export type GetEmployersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployersQuery = { employers?: Array<{ uuid?: string | null, slug?: string | null, name: string } | null> | null };

export type GetMemberPlanQueryVariables = Exact<{
  memberUuid: Scalars['ID'];
  employerUuid: Scalars['ID'];
}>;


export type GetMemberPlanQuery = { memberPlan?: { hasPrograms: boolean, planName: string, planUuid: string, eligibility: { eligible: boolean } } | null };

export type CreateNotifyOptInMutationVariables = Exact<{
  cappedProgramData: CreateNotifyOptInInput;
}>;


export type CreateNotifyOptInMutation = { createNotifyOptIn?: { academicPartnerUuid: string, createdAt?: any | null, programId: string } | null };

export type GetNotifyMeWhenOptInQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type GetNotifyMeWhenOptInQuery = { getNotifyMeWhenOptIn?: { programId?: string | null } | null };

export type OfferingCardFragment = { activatedAt?: any | null, completionTimeDisplay?: CompletionTimeDisplay | null, featured?: boolean | null, id: string, maxCompletionDays?: number | null, maxCompletionTimeDisplay?: number | null, minCompletionDays?: number | null, minCompletionTimeDisplay?: number | null, name: string, programFormat: string, shortProgramKind?: ShortProgramKind | null, uuid: string, concentrations: Array<{ id: string }>, nextDate?: { appDueDate?: string | null, startDate?: string | null } | null, studentFacingAcademicPartner?: { coachingIncluded: boolean, informalName: string, logoAltText?: string | null, merchandisingTier: AcademicPartnerMerchandisingTier, parentName: string } | null };

export type GetMemberProgramQueryVariables = Exact<{
  programId: Scalars['ID'];
  memberUuid: Scalars['ID'];
  employerUuid: Scalars['ID'];
}>;


export type GetMemberProgramQuery = { memberProgram?: { activatedAt?: any | null, completionTimeDisplay?: CompletionTimeDisplay | null, deferredTargetTermUuid?: string | null, description: string, featured?: boolean | null, fundingLevel?: number | null, id: string, maxCompletionDays?: number | null, maxCompletionTimeDisplay?: number | null, maxEffortHours?: number | null, minCompletionDays?: number | null, minCompletionTimeDisplay?: number | null, minEffortHours?: number | null, name: string, planProgramStatus?: string | null, programFormat: string, programKind?: ProgramKind | null, shortProgramKind?: ShortProgramKind | null, syllabusLink: string, uuid: string, visible: boolean, concentrations: Array<{ id: string }>, contentItems: Array<{ category?: ProgramContentItemCategory | null, title?: string | null, body?: string | null }>, nextDate?: { appDueDate?: string | null, startDate?: string | null } | null, requirements: { minCollegeCredits?: number | null, minCollegeCreditsDetails?: string | null, minCollegeGpa?: number | null, minCollegeGpaDetails?: string | null, minEduLevel?: MinEduLevel | null, minEduLevelDetails?: string | null, minHsGpa?: number | null, minHsGpaDetails?: string | null }, studentFacingAcademicPartner?: { academicModel: AcademicPartnerAcademicModel, accredited: boolean, coachingIncluded: boolean, image: string, informalName: string, logoAltText?: string | null, merchandisingTier: AcademicPartnerMerchandisingTier, name: string, nonProfit: boolean, overview: string, parentName: string, uuid: string, videoId: string, contentItems: Array<{ body?: string | null, category?: AcademicPartnerContentItemCategory | null, title?: string | null }>, logos: { color?: string | null } } | null } | null };

export type GetMemberProgramsV2QueryVariables = Exact<{
  programUuids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  version: Scalars['String'];
  memberUuid: Scalars['ID'];
  employerUuid: Scalars['ID'];
}>;


export type GetMemberProgramsV2Query = { memberPrograms?: Array<{ completionTimeDisplay?: CompletionTimeDisplay | null, fundingLevel?: number | null, id: string, maxCompletionDays?: number | null, maxCompletionTimeDisplay?: number | null, maxEffortHours?: number | null, minCompletionDays?: number | null, minCompletionTimeDisplay?: number | null, minEffortHours?: number | null, name: string, planProgramStatus?: string | null, programFormat: string, programKind?: ProgramKind | null, shortProgramKind?: ShortProgramKind | null, uuid: string, contentItems: Array<{ category?: ProgramContentItemCategory | null }>, facetOptions: Array<{ facetCategoryId?: number | null, name?: string | null }>, nextDate?: { appDueDate?: string | null, startDate?: string | null } | null, requirements: { minCollegeGpa?: number | null, minHsGpa?: number | null }, studentFacingAcademicPartner?: { coachingIncluded: boolean, informalName: string, logoAltText?: string | null, merchandisingTier: AcademicPartnerMerchandisingTier, parentName: string } | null } | null> | null };

export type GetMemberProgramStartDatesV2QueryVariables = Exact<{
  version: Scalars['String'];
  memberUuid: Scalars['ID'];
  employerUuid: Scalars['ID'];
}>;


export type GetMemberProgramStartDatesV2Query = { memberPrograms?: Array<{ uuid: string, nextDate?: { startDate?: string | null } | null } | null> | null };

export type GetRecommendationsQueryVariables = Exact<{
  version?: InputMaybe<Scalars['String']>;
}>;


export type GetRecommendationsQuery = { coachRecommendations?: Array<{ program?: { id: string, uuid: string } | null } | null> | null, coachRecommendationMessage?: { message?: string | null } | null, recommendations?: Array<{ program?: { id: string, uuid: string } | null } | null> | null, quizResponses?: Array<{ userUuid?: string | null, screenName?: QuizScreenName | null, ordering?: number | null, source?: QuizSource | null, response?: { booleanChoice?: boolean | null, singleChoice?: string | null, multipleChoice?: Array<string | null> | null } | null } | null> | null };

export type CreateRecommendationsAndQuizResponsesMutationVariables = Exact<{
  recommendationsInput: CreateRecommendationsAndQuizResponsesInput;
}>;


export type CreateRecommendationsAndQuizResponsesMutation = { createRecommendationsAndQuizResponses?: Array<{ program?: { id: string, uuid: string } | null } | null> | null };

export type CreateBookmarksMutationVariables = Exact<{
  bookmarks: CreateBookmarksInput;
}>;


export type CreateBookmarksMutation = { createBookmarks?: Array<{ program?: { id: string, name: string, uuid: string } | null } | null> | null };

export const OfferingCardFragmentDoc = gql`
    fragment OfferingCard on ProgramType {
  activatedAt
  completionTimeDisplay
  concentrations {
    id
  }
  featured
  id
  maxCompletionDays
  maxCompletionTimeDisplay
  minCompletionDays
  minCompletionTimeDisplay
  name
  nextDate {
    appDueDate
    startDate
  }
  programFormat
  shortProgramKind
  studentFacingAcademicPartner {
    coachingIncluded
    informalName
    logoAltText
    merchandisingTier
    parentName
  }
  uuid
}
    `;
export const GetBookmarksDocument = gql`
    query getBookmarks($version: String) {
  bookmarks(version: $version) {
    program {
      id
      uuid
    }
  }
}
    `;

/**
 * __useGetBookmarksQuery__
 *
 * To run a query within a React component, call `useGetBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarksQuery({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetBookmarksQuery(baseOptions?: Apollo.QueryHookOptions<GetBookmarksQuery, GetBookmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(GetBookmarksDocument, options);
      }
export function useGetBookmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookmarksQuery, GetBookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(GetBookmarksDocument, options);
        }
export type GetBookmarksQueryHookResult = ReturnType<typeof useGetBookmarksQuery>;
export type GetBookmarksLazyQueryHookResult = ReturnType<typeof useGetBookmarksLazyQuery>;
export type GetBookmarksQueryResult = Apollo.QueryResult<GetBookmarksQuery, GetBookmarksQueryVariables>;
export const GetEmployersDocument = gql`
    query getEmployers {
  employers {
    uuid
    slug
    name
  }
}
    `;

/**
 * __useGetEmployersQuery__
 *
 * To run a query within a React component, call `useGetEmployersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployersQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployersQuery, GetEmployersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployersQuery, GetEmployersQueryVariables>(GetEmployersDocument, options);
      }
export function useGetEmployersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployersQuery, GetEmployersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployersQuery, GetEmployersQueryVariables>(GetEmployersDocument, options);
        }
export type GetEmployersQueryHookResult = ReturnType<typeof useGetEmployersQuery>;
export type GetEmployersLazyQueryHookResult = ReturnType<typeof useGetEmployersLazyQuery>;
export type GetEmployersQueryResult = Apollo.QueryResult<GetEmployersQuery, GetEmployersQueryVariables>;
export const GetMemberPlanDocument = gql`
    query getMemberPlan($memberUuid: ID!, $employerUuid: ID!) {
  memberPlan(memberUuid: $memberUuid, employerUuid: $employerUuid) {
    eligibility {
      eligible
    }
    hasPrograms
    planName
    planUuid
  }
}
    `;

/**
 * __useGetMemberPlanQuery__
 *
 * To run a query within a React component, call `useGetMemberPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPlanQuery({
 *   variables: {
 *      memberUuid: // value for 'memberUuid'
 *      employerUuid: // value for 'employerUuid'
 *   },
 * });
 */
export function useGetMemberPlanQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPlanQuery, GetMemberPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPlanQuery, GetMemberPlanQueryVariables>(GetMemberPlanDocument, options);
      }
export function useGetMemberPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPlanQuery, GetMemberPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPlanQuery, GetMemberPlanQueryVariables>(GetMemberPlanDocument, options);
        }
export type GetMemberPlanQueryHookResult = ReturnType<typeof useGetMemberPlanQuery>;
export type GetMemberPlanLazyQueryHookResult = ReturnType<typeof useGetMemberPlanLazyQuery>;
export type GetMemberPlanQueryResult = Apollo.QueryResult<GetMemberPlanQuery, GetMemberPlanQueryVariables>;
export const CreateNotifyOptInDocument = gql`
    mutation createNotifyOptIn($cappedProgramData: CreateNotifyOptInInput!) {
  createNotifyOptIn(cappedProgramData: $cappedProgramData) {
    academicPartnerUuid
    createdAt
    programId
  }
}
    `;
export type CreateNotifyOptInMutationFn = Apollo.MutationFunction<CreateNotifyOptInMutation, CreateNotifyOptInMutationVariables>;

/**
 * __useCreateNotifyOptInMutation__
 *
 * To run a mutation, you first call `useCreateNotifyOptInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotifyOptInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotifyOptInMutation, { data, loading, error }] = useCreateNotifyOptInMutation({
 *   variables: {
 *      cappedProgramData: // value for 'cappedProgramData'
 *   },
 * });
 */
export function useCreateNotifyOptInMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotifyOptInMutation, CreateNotifyOptInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotifyOptInMutation, CreateNotifyOptInMutationVariables>(CreateNotifyOptInDocument, options);
      }
export type CreateNotifyOptInMutationHookResult = ReturnType<typeof useCreateNotifyOptInMutation>;
export type CreateNotifyOptInMutationResult = Apollo.MutationResult<CreateNotifyOptInMutation>;
export type CreateNotifyOptInMutationOptions = Apollo.BaseMutationOptions<CreateNotifyOptInMutation, CreateNotifyOptInMutationVariables>;
export const GetNotifyMeWhenOptInDocument = gql`
    query getNotifyMeWhenOptIn($programId: ID!) {
  getNotifyMeWhenOptIn(programId: $programId) {
    programId
  }
}
    `;

/**
 * __useGetNotifyMeWhenOptInQuery__
 *
 * To run a query within a React component, call `useGetNotifyMeWhenOptInQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotifyMeWhenOptInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotifyMeWhenOptInQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetNotifyMeWhenOptInQuery(baseOptions: Apollo.QueryHookOptions<GetNotifyMeWhenOptInQuery, GetNotifyMeWhenOptInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotifyMeWhenOptInQuery, GetNotifyMeWhenOptInQueryVariables>(GetNotifyMeWhenOptInDocument, options);
      }
export function useGetNotifyMeWhenOptInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotifyMeWhenOptInQuery, GetNotifyMeWhenOptInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotifyMeWhenOptInQuery, GetNotifyMeWhenOptInQueryVariables>(GetNotifyMeWhenOptInDocument, options);
        }
export type GetNotifyMeWhenOptInQueryHookResult = ReturnType<typeof useGetNotifyMeWhenOptInQuery>;
export type GetNotifyMeWhenOptInLazyQueryHookResult = ReturnType<typeof useGetNotifyMeWhenOptInLazyQuery>;
export type GetNotifyMeWhenOptInQueryResult = Apollo.QueryResult<GetNotifyMeWhenOptInQuery, GetNotifyMeWhenOptInQueryVariables>;
export const GetMemberProgramDocument = gql`
    query getMemberProgram($programId: ID!, $memberUuid: ID!, $employerUuid: ID!) {
  memberProgram(programId: $programId, memberUuid: $memberUuid, employerUuid: $employerUuid) {
    activatedAt
    completionTimeDisplay
    concentrations {
      id
    }
    contentItems {
      category
      title
      body
    }
    deferredTargetTermUuid
    description
    featured
    fundingLevel
    id
    maxCompletionDays
    maxCompletionTimeDisplay
    maxEffortHours
    minCompletionDays
    minCompletionTimeDisplay
    minEffortHours
    name
    nextDate {
      appDueDate
      startDate
    }
    planProgramStatus
    programFormat
    programKind
    requirements {
      minCollegeCredits
      minCollegeCreditsDetails
      minCollegeGpa
      minCollegeGpaDetails
      minEduLevel
      minEduLevelDetails
      minHsGpa
      minHsGpaDetails
    }
    shortProgramKind
    studentFacingAcademicPartner {
      academicModel
      accredited
      coachingIncluded
      contentItems {
        body
        category
        title
      }
      image
      informalName
      logoAltText
      logos {
        color
      }
      merchandisingTier
      name
      nonProfit
      overview
      parentName
      uuid
      videoId
    }
    syllabusLink
    uuid
    visible
  }
}
    `;

/**
 * __useGetMemberProgramQuery__
 *
 * To run a query within a React component, call `useGetMemberProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      memberUuid: // value for 'memberUuid'
 *      employerUuid: // value for 'employerUuid'
 *   },
 * });
 */
export function useGetMemberProgramQuery(baseOptions: Apollo.QueryHookOptions<GetMemberProgramQuery, GetMemberProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberProgramQuery, GetMemberProgramQueryVariables>(GetMemberProgramDocument, options);
      }
export function useGetMemberProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberProgramQuery, GetMemberProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberProgramQuery, GetMemberProgramQueryVariables>(GetMemberProgramDocument, options);
        }
export type GetMemberProgramQueryHookResult = ReturnType<typeof useGetMemberProgramQuery>;
export type GetMemberProgramLazyQueryHookResult = ReturnType<typeof useGetMemberProgramLazyQuery>;
export type GetMemberProgramQueryResult = Apollo.QueryResult<GetMemberProgramQuery, GetMemberProgramQueryVariables>;
export const GetMemberProgramsV2Document = gql`
    query getMemberProgramsV2($programUuids: [ID!], $version: String!, $memberUuid: ID!, $employerUuid: ID!) {
  memberPrograms(programUuids: $programUuids, version: $version, memberUuid: $memberUuid, employerUuid: $employerUuid) {
    completionTimeDisplay
    contentItems {
      category
    }
    facetOptions {
      facetCategoryId
      name
    }
    fundingLevel
    id
    maxCompletionDays
    maxCompletionTimeDisplay
    maxEffortHours
    minCompletionDays
    minCompletionTimeDisplay
    minEffortHours
    name
    nextDate {
      appDueDate
      startDate
    }
    planProgramStatus
    programFormat
    programKind
    requirements {
      minCollegeGpa
      minHsGpa
    }
    shortProgramKind
    studentFacingAcademicPartner {
      coachingIncluded
      informalName
      logoAltText
      merchandisingTier
      parentName
    }
    uuid
  }
}
    `;

/**
 * __useGetMemberProgramsV2Query__
 *
 * To run a query within a React component, call `useGetMemberProgramsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberProgramsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberProgramsV2Query({
 *   variables: {
 *      programUuids: // value for 'programUuids'
 *      version: // value for 'version'
 *      memberUuid: // value for 'memberUuid'
 *      employerUuid: // value for 'employerUuid'
 *   },
 * });
 */
export function useGetMemberProgramsV2Query(baseOptions: Apollo.QueryHookOptions<GetMemberProgramsV2Query, GetMemberProgramsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberProgramsV2Query, GetMemberProgramsV2QueryVariables>(GetMemberProgramsV2Document, options);
      }
export function useGetMemberProgramsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberProgramsV2Query, GetMemberProgramsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberProgramsV2Query, GetMemberProgramsV2QueryVariables>(GetMemberProgramsV2Document, options);
        }
export type GetMemberProgramsV2QueryHookResult = ReturnType<typeof useGetMemberProgramsV2Query>;
export type GetMemberProgramsV2LazyQueryHookResult = ReturnType<typeof useGetMemberProgramsV2LazyQuery>;
export type GetMemberProgramsV2QueryResult = Apollo.QueryResult<GetMemberProgramsV2Query, GetMemberProgramsV2QueryVariables>;
export const GetMemberProgramStartDatesV2Document = gql`
    query getMemberProgramStartDatesV2($version: String!, $memberUuid: ID!, $employerUuid: ID!) {
  memberPrograms(version: $version, memberUuid: $memberUuid, employerUuid: $employerUuid) {
    nextDate {
      startDate
    }
    uuid
  }
}
    `;

/**
 * __useGetMemberProgramStartDatesV2Query__
 *
 * To run a query within a React component, call `useGetMemberProgramStartDatesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberProgramStartDatesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberProgramStartDatesV2Query({
 *   variables: {
 *      version: // value for 'version'
 *      memberUuid: // value for 'memberUuid'
 *      employerUuid: // value for 'employerUuid'
 *   },
 * });
 */
export function useGetMemberProgramStartDatesV2Query(baseOptions: Apollo.QueryHookOptions<GetMemberProgramStartDatesV2Query, GetMemberProgramStartDatesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberProgramStartDatesV2Query, GetMemberProgramStartDatesV2QueryVariables>(GetMemberProgramStartDatesV2Document, options);
      }
export function useGetMemberProgramStartDatesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberProgramStartDatesV2Query, GetMemberProgramStartDatesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberProgramStartDatesV2Query, GetMemberProgramStartDatesV2QueryVariables>(GetMemberProgramStartDatesV2Document, options);
        }
export type GetMemberProgramStartDatesV2QueryHookResult = ReturnType<typeof useGetMemberProgramStartDatesV2Query>;
export type GetMemberProgramStartDatesV2LazyQueryHookResult = ReturnType<typeof useGetMemberProgramStartDatesV2LazyQuery>;
export type GetMemberProgramStartDatesV2QueryResult = Apollo.QueryResult<GetMemberProgramStartDatesV2Query, GetMemberProgramStartDatesV2QueryVariables>;
export const GetRecommendationsDocument = gql`
    query getRecommendations($version: String) {
  coachRecommendations(version: $version) {
    program {
      id
      uuid
    }
  }
  coachRecommendationMessage {
    message
  }
  recommendations(version: $version) {
    program {
      id
      uuid
    }
  }
  quizResponses {
    userUuid
    screenName
    response {
      booleanChoice
      singleChoice
      multipleChoice
    }
    ordering
    source
  }
}
    `;

/**
 * __useGetRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationsQuery({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecommendationsQuery, GetRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendationsQuery, GetRecommendationsQueryVariables>(GetRecommendationsDocument, options);
      }
export function useGetRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendationsQuery, GetRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendationsQuery, GetRecommendationsQueryVariables>(GetRecommendationsDocument, options);
        }
export type GetRecommendationsQueryHookResult = ReturnType<typeof useGetRecommendationsQuery>;
export type GetRecommendationsLazyQueryHookResult = ReturnType<typeof useGetRecommendationsLazyQuery>;
export type GetRecommendationsQueryResult = Apollo.QueryResult<GetRecommendationsQuery, GetRecommendationsQueryVariables>;
export const CreateRecommendationsAndQuizResponsesDocument = gql`
    mutation createRecommendationsAndQuizResponses($recommendationsInput: CreateRecommendationsAndQuizResponsesInput!) {
  createRecommendationsAndQuizResponses(recommendationsInput: $recommendationsInput) {
    program {
      id
      uuid
    }
  }
}
    `;
export type CreateRecommendationsAndQuizResponsesMutationFn = Apollo.MutationFunction<CreateRecommendationsAndQuizResponsesMutation, CreateRecommendationsAndQuizResponsesMutationVariables>;

/**
 * __useCreateRecommendationsAndQuizResponsesMutation__
 *
 * To run a mutation, you first call `useCreateRecommendationsAndQuizResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecommendationsAndQuizResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecommendationsAndQuizResponsesMutation, { data, loading, error }] = useCreateRecommendationsAndQuizResponsesMutation({
 *   variables: {
 *      recommendationsInput: // value for 'recommendationsInput'
 *   },
 * });
 */
export function useCreateRecommendationsAndQuizResponsesMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecommendationsAndQuizResponsesMutation, CreateRecommendationsAndQuizResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecommendationsAndQuizResponsesMutation, CreateRecommendationsAndQuizResponsesMutationVariables>(CreateRecommendationsAndQuizResponsesDocument, options);
      }
export type CreateRecommendationsAndQuizResponsesMutationHookResult = ReturnType<typeof useCreateRecommendationsAndQuizResponsesMutation>;
export type CreateRecommendationsAndQuizResponsesMutationResult = Apollo.MutationResult<CreateRecommendationsAndQuizResponsesMutation>;
export type CreateRecommendationsAndQuizResponsesMutationOptions = Apollo.BaseMutationOptions<CreateRecommendationsAndQuizResponsesMutation, CreateRecommendationsAndQuizResponsesMutationVariables>;
export const CreateBookmarksDocument = gql`
    mutation createBookmarks($bookmarks: CreateBookmarksInput!) {
  createBookmarks(bookmarks: $bookmarks) {
    program {
      id
      name
      uuid
    }
  }
}
    `;
export type CreateBookmarksMutationFn = Apollo.MutationFunction<CreateBookmarksMutation, CreateBookmarksMutationVariables>;

/**
 * __useCreateBookmarksMutation__
 *
 * To run a mutation, you first call `useCreateBookmarksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarksMutation, { data, loading, error }] = useCreateBookmarksMutation({
 *   variables: {
 *      bookmarks: // value for 'bookmarks'
 *   },
 * });
 */
export function useCreateBookmarksMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarksMutation, CreateBookmarksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarksMutation, CreateBookmarksMutationVariables>(CreateBookmarksDocument, options);
      }
export type CreateBookmarksMutationHookResult = ReturnType<typeof useCreateBookmarksMutation>;
export type CreateBookmarksMutationResult = Apollo.MutationResult<CreateBookmarksMutation>;
export type CreateBookmarksMutationOptions = Apollo.BaseMutationOptions<CreateBookmarksMutation, CreateBookmarksMutationVariables>;